<template>
  <div class="sidebar">
    <v-navigation-drawer
      v-model="navDrawer"
      class="sidebar__nav"
      :mini-variant="miniNavDrawer"
      mobile-break-point="960"
      app
    >
      <template v-slot:prepend>
        <div class="sidebar__logo">
          <v-list dense>
            <v-list-item>
              <v-list-item-action class="mr-3">
                <img class="sidebar__logo-typo" src="@/assets/img/logo-syg-dark.svg" alt="logo" />
              </v-list-item-action>
              <v-list-item-content class="flex-column align-start justify-start">
                <img class="sidebar__logo-typo" src="@/assets/img/logo-typo-dark.svg" alt="logo" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>

        <v-btn
          class="sidebar__open-toggle-btn"
          :class="{ 'sidebar__open-toggle-btn--closed': isMenuOpen }"
          depressed
          fab
          dark
          color="blue"
          height="32"
          width="32"
          @click="open"
        >
          <v-icon dark>mdi-chevron-left</v-icon>
        </v-btn>
      </template>

      <div v-if="!miniNavDrawer" class="sidebar__title">Menu</div>

      <SidebarClientMenu v-if="currentRole === 'client'" />

      <SidebarHrMenu v-else />

      <template v-slot:append>
        <v-list dense>
          <v-list-item class="pl-3">
            <v-list-item-avatar color="blue" size="32">
              <v-icon color="white">mdi-account-circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-title>
              <div class="sidebar__user-name">{{ user.first_name }} {{ user.last_name }}</div>
              <div class="sidebar__user-email">{{ user.email }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list dense>
          <v-list-item @click="logout">
            <v-list-item-action>
              <v-icon small>mdi-logout-variant</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <ConfirmDialog ref="confirmDialog" />
  </div>
</template>

<script>
import sessionsApi from '@/api/v1/sessions';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import SidebarClientMenu from '@/components/SidebarClientMenu.vue';
import SidebarHrMenu from '@/components/SidebarHrMenu.vue';

export default {
  components: {
    ConfirmDialog,
    SidebarClientMenu,
    SidebarHrMenu,
  },

  data() {
    return {
      navDrawer: null,
      miniNavDrawer: false,
      user: {
        first_name: '',
        last_name: '',
        email: '',
      },
    };
  },

  computed: {
    currentRole() {
      return this.$store.state.auth.role;
    },

    isFullSidebarBreakpoint() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    isMenuOpen() {
      const isOpen = this.isFullSidebarBreakpoint ? this.miniNavDrawer : !this.navDrawer;
      return isOpen;
    },
  },

  watch: {
    isFullSidebarBreakpoint() {
      this.initSidebarBehaviour();
    },
  },

  created() {
    this.fetchUserData();
  },

  mounted() {
    this.initSidebarBehaviour();
  },

  methods: {
    initSidebarBehaviour() {
      if (this.isFullSidebarBreakpoint) {
        this.navDrawer = true;
      } else {
        this.navDrawer = false;
        this.miniNavDrawer = false;
      }
    },

    open() {
      if (this.isFullSidebarBreakpoint) {
        this.miniNavDrawer = !this.miniNavDrawer;
      } else {
        this.navDrawer = !this.navDrawer;
      }
    },

    fetchUserData() {
      sessionsApi.getProfile(this.$store.state.auth.role)
        .then((resp) => {
          this.user = resp.data;
        });
    },

    logout() {
      this.$refs.confirmDialog
        .open({
          message: 'Are you sure you want to logout?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        })
        .then((confirm) => {
          if (confirm) {
            this.$store.dispatch('auth/logout');
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  &__nav {
    overflow: visible;
    box-shadow: 0px 3px 6px #00000029;
  }

  &__open-toggle-btn {
    position: absolute;
    right: -32px;
    z-index: 99999;
    top: 75px;
    transition: all 0.4s ease;

    @include tablet-xl {
      right: -16px;
    }

    &--closed {
      transform: rotate(180deg);
    }
  }

  &__logo {
    margin-bottom: 6vh;
  }

  &__logo-typo {
    max-width: 100%;
    transition: all 0.3s ease;
  }

  &__title {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    margin-left: 16px;
  }

  &__user-name {
    font-size: 14px;
    line-height: 16px;
  }
  &__user-email {
    font-size: 12px;
    line-height: 14px;
    color: $color--blue;
  }
}
.nav-list {
  &__notifications {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
